/**
 * Enrollment status values for pathway enrollments
 */
export enum PathwayEnrollmentStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  WITHDRAWN = 'WITHDRAWN',
  LOCKED = 'LOCKED'
}

/**
 * Step type values for pathway steps
 */
export enum PathwayStepType {
  INTRO = 'INTRO',
  PRACTICE_CALL = 'PRACTICE_CALL',
  CERTIFICATION_CALL = 'CERTIFICATION_CALL',
  DEBRIEF_CALL = 'DEBRIEF_CALL',
  LEARN_WITH_X = 'LEARN_WITH_X',
  QUIZ = 'QUIZ',
  LEARN = 'LEARN',
}

/**
 * Step state values for pathway enrollment steps
 */
export enum PathwayStepState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  STOPPED = 'STOPPED',
  OUT_OF_ATTEMPTS = 'OUT_OF_ATTEMPTS',
  ABANDONED = 'ABANDONED',
}
